import { put, takeEvery, call } from "redux-saga/effects";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import endpoints from "../endpoints";
import api from "../api";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type:'Web'
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}` });

//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

function* commonPostFunction(value) {
  const token = localStorage.getItem("fmsToken");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        type: "Web",
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      yield put({
        type: `${value.initAction}`,
      });

      yield toast.success(value.toastMsg, {
        autoClose: 3000,
      });
      return resJSON;
    }
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield put({ type: `${value.failAction}`, error: err });
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchOnboardingResData() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    filter: "Total",
    type: "Unapproved",
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
      method: "POST",
      sucessAction: actionTypes.FETCH_ONBOARDINGRESIDENTSDATA_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_ONBOARDINGRESIDENTSDATA_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(api.commonGetFunction, params);
    return Res;
  } catch (e) {}
}

function* addApprovedResData(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    aptlist: value.value,
  };
  try {
    let params = {
      api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/approveapts`,
      method: "POST",
      sucessAction: actionTypes.APPROVE_ONBOARDINGRESIDENTSDATA_SUCCESS_ACTION,
      toastMsg: "Residents data approved successfully",
      initAction: actionTypes.FETCH_ONBOARDINGRESIDENTSDATA_INIT_ACTION,
      failAction: actionTypes.APPROVE_ONBOARDINGRESIDENTSDATA_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    const Res = yield call(commonPostFunction, params);
    return Res;
  } catch (e) {}
}

export function* onboardingResActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_ONBOARDINGRESIDENTSDATA_INIT_ACTION,
    fetchOnboardingResData
  );
  yield takeEvery(
    actionTypes.APPROVE_ONBOARDINGRESIDENTSDATA_INIT_ACTION,
    addApprovedResData
  );
}
